<template>
  <div class="versus-wrap">
    <back-button :tag="false" />
    <!-- <img class="versus-logo" src="@/assets/img/versus-logo.png" /> -->
    <div class="versus-rule">
      <div class="rule-title">
        <img src="@/assets/img/rule-header.png" />
      </div>
      <p>用户参与挑战模式，系统为用户随机匹配PK对手。</p>
      <p>匹配成功后开始进行对战答题，每次根据答题正确数量和用时确定胜方。</p>
      <p>最终正确作答3题及以上，高得分且用时较短者获得胜利；</p>
      <p>若正确作答数量相同（3题及以上）则用时较短者获得胜利；</p>
      <p>胜利者可获得1次抽奖机会，并获得5分。若未达到上述条件则不得分。</p>
      <p>每日最多可参与100次挑战。</p>
    </div>
    <div class="versus-btn">
      <img src="@/assets/img/versus-btn.png" @click="goVersus" />
    </div>
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    BackButton,
  },
  data() {
    return {};
  },
  mounted() {
    this.reset();
    if (this.user.token) {
      this.initSocket();
    } else {
      this.getUserInfo().then(() => this.initSocket());
    }
  },
  computed: {
    ...mapState("versus", ["socket"]),
    user() {
      return this.$store.state.user.user;
    },
    // state() {
    //   return this.$store.state.versus.socket?.readyState;
    // },
  },
  methods: {
    ...mapActions("versus", ["initSocket", "reset"]),
    goVersus() {
      if (new Date().getTime() < 1785427199000) {
        this.$notify({
          type: "danger",
          message: "活动未开始",
          duration: 2000,
        });
      } else {
        if (this.user.token) {
          this.$router.push("/versus/game");
        } else {
          this.$notify({
            type: "danger",
            message: "请完善用户信息",
            duration: 2000,
          });
        }
      }
    },
    async getUserInfo() {
      try {
        const res = await this.$axios.post(`/User/getUserInfo`);
        this.$store.commit("user/SET_USER", res.data);
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || "获取用户信息失败",
          duration: 2000,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.versus-wrap {
  @include index-bg;
  .versus-title {
    padding: 20px 0;
    font-size: 18px;
    text-align: center;
    background: #fff;
  }
  .versus-logo {
    width: 100%;
  }
  .versus-btn {
    text-align: center;
    img {
      width: 200px;
      cursor: pointer;
    }
  }
  .versus-rule {
    padding: 30px;
    margin: 120px 20px 23px;
    font-size: 12px;
    color: #716c6c;
    text-align: justify;
    background: url("~@/assets/img/rule-bg.png") no-repeat center center;
    background-size: 100% 100%;

    .rule-title {
      display: flex;
      justify-content: center;
      padding-bottom: 20px;
      margin-bottom: 30px;
      border-bottom: 1px solid #2347ff;
      img {
        display: block;
        width: 120px;
        height: auto;
      }
    }
  }
}
</style>
